import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RenderCreateMenus, { createMenus } from "../utils/renderCreateMenus";
import Header from "../components/Header/Header";
import { Card } from "react-bootstrap";
import Sidebar from "../components/Sidebar/SideBar";
import "../layout/style.css";
import { authUser } from "../redux/slice/AuthSlice";
import { useDispatch } from "react-redux";
import { FaSearch } from "react-icons/fa";
import { usePic } from "../context/PicProvider";

const Layout = ({ children }) => {
  const location = useLocation();
  const {
    searchQuery,
    setSearchQuery,
    setCurrentPage,
    showSearch,
    searchPlaceholder,
  } = usePic();
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();

  // Toggle the sidebar state
  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const removeSideBarActive = () => {
    setIsActive(!isActive);
  };

  // Dispatch authUser action on component mount
  useEffect(() => {
    dispatch(authUser());
  }, [dispatch]);

  // Determine whether to hide the search bar based on the current route
  const hideSearch = location.pathname === "/"; // hide search bar when on the dashboard
  const isTransparent = (url) => {
    const transparentScreen = [
      /^\/$/, // Matches "/"
      /^\/reports$/, // Matches "/reports"
      /^\/edit-notification$/, // Matches "/edit-notification"
      /^\/editarticle$/, // Matches "/editarticle"
      /^\/businessprofile$/, // Matches "/businessprofile"
      /^\/distributorinfo$/, // Matches "/distributorinfo"
      /^\/createlocation$/, // Matches "/createlocation"
      /^\/create-users$/, // Matches "/create-users"
      /^\/update-user\/[a-zA-Z0-9]+$/, // Matches "/update-user/{id}"
      /^\/creategroupreport$/,
      /^\/reporteditor$/,
      /^\/edit_report_listing\/[a-zA-Z0-9]+$/,
      /^\/edit_report_group\/[a-zA-Z0-9]+$/,
      /^\/distributor$/, // Matches "/distributor"
      /^\/distributor-create-user$/,
      /^\/update-distributor\/[a-zA-Z0-9]+$/,
      /^\/distributor-invite-admin$/,
      /^\/distributor-update-distributor-user\/[a-zA-Z0-9]+$/,
      /^\/distributor-business-profile$/, // Matches "/distributor-business-profile"
      /^\/distributor-create-location$/, // Matches "/distributor-create-location"
      /^\/createemptykit$/,
      /^\/createkit$/,
    ];

    return transparentScreen.some((pattern) => pattern.test(url));
  };

  return (
    <div className="wrapper">
      <Sidebar isActive={isActive} removeSideBarActive={removeSideBarActive} />
      <div className="main_container">
        <Header
          isActive={isActive}
          toggleClass={toggleClass}
          hideSearch={hideSearch}
        />
        <div className="position-relative flex-grow-1">
          <div className="right_content_wrapper position-absolute w-100 h-100 d-flex flex-column">
            {/* Conditionally render CreateMenus based on the pathname */}
            {(createMenus[location.pathname] || showSearch) && (
              <div className="top-bar-wrapper data-table-search">
                {createMenus[location.pathname] && (
                  <RenderCreateMenus pathname={location.pathname} />
                )}
                {showSearch && (
                  <div className="search">
                    <input
                      type="text"
                      placeholder={searchPlaceholder}
                      // className="search-input"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <FaSearch className="search-icon" />
                  </div>
                )}
              </div>
            )}

            {/* Render the main content within a Card component */}
            <Card
              className={`content_block flex-grow-1 overflow-y-auto overflow-x-hidden ${
                isTransparent(location.pathname)
                  ? "content_block-padding-none"
                  : "content_block-padding"
              }`}
              style={{
                border: "none",
                borderRadius: "16px",
                backgroundColor: isTransparent(location.pathname)
                  ? "transparent"
                  : "white",
              }}
            >
              {children}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
